<script setup lang="ts">
definePageMeta({
  name: "kundeservice",
});
</script>

<template>
  <UiAdditionalInformation path="/tilleggsopplysninger/kundeservice" />
</template>
